import React from 'react';
import UnicornStudioRenderer from './UnicornStudioRenderer';
import { IhomepageSetting } from '@typings/setting/homepageSetting.interface';

type Props = {
  homeSet: IhomepageSetting | null;
};

function WebglBackground({ homeSet }: Props) {
  // WebGL 설정이 없거나 비활성화되어 있으면 렌더하지 않음
  if (!homeSet?.background?.webgl?.enabled) {
    return null;
  }

  const webglConfig = homeSet.background.webgl;

  // 활성화된 프리셋 찾기
  const activePreset = webglConfig.presets?.find(p => p.id === webglConfig.activePresetId);

  if (!activePreset || !activePreset.projectId) {
    console.warn('WebGL 배경: 활성화된 프리셋이 없거나 프로젝트 ID가 없습니다.');
    return null;
  }

  return (
    <UnicornStudioRenderer
      projectId={activePreset.projectId}
      width={Number(activePreset.width) || 1440}
      height={Number(activePreset.height) || 900}
      opacity={Number(activePreset.params?.opacity) || 1}
    />
  );
}

export default WebglBackground;

